import { Injectable } from "@angular/core";
import { environment } from "../../../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { RequestTokenService } from "../../../../../../services/request-token.service";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { UsuarioSignature } from "../../models/signature/UsuarioSignature";
import { AtualizaNovaSenhaSignature } from "../../models/signature/AtualizaNovaSenhaSignature";
import { ExcluirUsuarioSistemaSignature } from "../../models/signature/ExcluirUsuarioSistemaSignature";

const API_URL = `${environment.apiUrl}v6/CadastroUsuario`;

@Injectable({
  providedIn: 'root'
})

export class CadastroUsuarioService {

  constructor(private http: HttpClient,
    private requestToken: RequestTokenService
  ) {}

  private handleError(error: any): Observable<never> {
    console.error('An error occurred', error);
    return throwError(error);
  }

  public GetListaUsuarios(): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.get<any>(`${API_URL}/GetListaUsuarios`, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public InsertUsuario(signature: UsuarioSignature): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.post<any>(`${API_URL}/InsertUsuario`, signature, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public UpdateUsuario(signature: UsuarioSignature): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.post<any>(`${API_URL}/UpdateUsuario`, signature, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public ResetSenhaUsuario(signature: UsuarioSignature): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.post<any>(`${API_URL}/ResetSenhaUsuario`, signature, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public JaExistCpfUsuario(signature: UsuarioSignature): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.post<any>(`${API_URL}/JaExistCpfUsuario`, signature, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public JaExistEmailUsuario(signature: UsuarioSignature): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.post<any>(`${API_URL}/JaExistEmailUsuario`, signature, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public UpdateNovaSenha(signature: AtualizaNovaSenhaSignature): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.post<any>(`${API_URL}/UpdateNovaSenha`, signature, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public ExcluirUsuarioSistema(signature: ExcluirUsuarioSistemaSignature): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.post<any>(`${API_URL}/ExcluirUsuarioSistema`, signature, options)
    .pipe(
      catchError(this.handleError)
    )
  }
}
